import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  leftContainer: FelaCSS;
  rightContainer: FelaCSS;
  authorPicture: FelaCSS;
  authorName: FelaCSS;
  authorTitle: FelaCSS;
  startPlanningWrapper: FelaCSS;
  title: FelaCSS;
  subTitle: FelaCSS;
  signupButton: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    width: '60%',
    maxWidthTablet: {
      width: '100%',
    },
    maxWidthMobile: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  leftContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '50%',
    maxWidthMobile: {
      width: '80%',
    },
  },
  rightContainer: {
    width: '50%',
    fontDefaultLight: 20,
    color: colors.space75,
    whiteSpace: 'pre-wrap',
    maxWidthMobile: {
      width: '80%',
      marginTop: 8,
    },
  },
  authorPicture: {
    width: 150,
    height: 150,
    borderRadius: '50%',
    marginVertical: 2,
  },
  authorName: {
    fontDefaultSemiBold: 24,
    marginBottom: 2,
  },
  authorTitle: {
    fontDefault: 14,
    marginBottom: 2,
  },
  startPlanningWrapper: {
    flexDirection: 'row',
    backgroundColor: colors.indigoCrush04,
    paddingVertical: 4,
    paddingHorizontal: 5,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 16,
    gap: 50,
    marginVertical: 6,
    desktopDesign: {
      paddingHorizontal: 8,
    },
  },
  title: {
    fontDefaultSemiBold: 18,
    lineHeight: '27px',
  },
  subTitle: {
    fontDefault: 14,
    lineHeight: '21px',
  },
  signupButton: {
    maxWidthMobile: {
      minWidth: 100,
    },
  },
});

export default styles;
